import type { SSRData } from 'urql';

/**
 * Returns the urql SSR payload without the entries of operations that failed.
 *
 * urql serializes a failed operation with `undefined` fields (e.g.
 * `graphQLErrors[].path`), which Next.js refuses to serialize into page props
 * and turns into a 500 for the whole page. Dropping those entries also lets the
 * client retry the query instead of hydrating a permanent error, so a failing
 * prefetch degrades to the previous client-side fetch.
 */
export const extractSsrState = (ssrCache: { extractData: () => SSRData }): SSRData =>
  Object.fromEntries(Object.entries(ssrCache.extractData()).filter(([, result]) => !result?.error));
